import request from "../shared/http";

const cache = {};

class GeoService {
  async fetchCountries() {
    if (!cache.countries) {
      const response = await request.get('/countries');
      cache.countries = response.data;
    }
    return cache.countries;
  }

  getCountries() {
    return cache.countries;
  }

  async fetchCurrencies() {
    if (!cache.currencies) {
      const response = await request.get('/currencies');
      cache.currencies = response.data;
    }
    return cache.currencies;
  }

  getCurrencies() {
    return cache.currencies;
  }

  getCurrencyByCode(code) {
    return cache.currencies?.find((model) => model.code === code);
  }

  async fetchTimeZones() {
    if (!cache.timeZones) {
      const response = await request.get('/timezones');
      cache.timeZones = response.data;
    }
    return cache.timeZones;
  }

  getTimeZones() {
    return cache.timeZones;
  }
}

export default new GeoService();
